const LOADER_ID = "js-page-loader"

const hideAllLoaders = (): void => {
  document
    .querySelectorAll<HTMLElement>(`#${LOADER_ID}, .ui-component-loader.variant\\:spinner`)
    .forEach((el) => (el.hidden = true))
}

const startPageLoader = (): void => {
  document.getElementById(LOADER_ID)!.hidden = false
}

const stopPageLoader = (): void => {
  document.getElementById(LOADER_ID)!.hidden = true
}

export { hideAllLoaders, startPageLoader, stopPageLoader }
